import { useEffect, useState } from 'react'

import Api from 'services/api'

import { NotificationRecipient } from 'types/NotificationRecipient'

const useNotificationRecipient = (dealerId: number, notificationRecipientId: number) => {
  const [notificationRecipient, setNotificationRecipient] = useState<NotificationRecipient | null>(null)
  const [isNotificationRecipientLoaded, setIsNotificationRecipientLoaded] = useState(false)

  useEffect(() => {
    if (!notificationRecipientId) {
      setIsNotificationRecipientLoaded(true)
      setNotificationRecipient({ dealerId })
    } else {
      Api.NotificationRecipients.get(dealerId, notificationRecipientId)
        .then((res) => {
          setNotificationRecipient(res)
          setIsNotificationRecipientLoaded(true)
        })
        .catch(() => {
          setNotificationRecipient(null)
          setIsNotificationRecipientLoaded(true)
        })
    }
  }, [dealerId, notificationRecipientId])

  return { notificationRecipient, isNotificationRecipientLoaded }
}

export default useNotificationRecipient
